var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-base"},[(_vm.QDong.photoUrl)?_c('el-image',{staticClass:"img",attrs:{"src":'http://'+_vm.QDong.photoUrl,"fit":"cover"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }